"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearData = exports.setOrder = exports.setAddresses = exports.setShippingAddress = exports.setBillingAddress = exports.setEmail = exports.setShippingAddressSameAsBilling = exports.setBillingCountry = exports.setShippingCountry = exports.setEmailConsentForDelivery = exports.setAdditionalInformation = exports["default"] = exports.checkoutDataSlice = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toolkit = require("@reduxjs/toolkit");
var _excluded = ["save_in_address_book", "isParcel", "isLocker", "email"],
  _excluded2 = ["email"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var emptyAddress = {
  firstName: "",
  lastName: "",
  street: "",
  city: "",
  postalCode: "",
  country: {
    id: null
  },
  phone: "",
  isCompany: false,
  companyName: "",
  vatId: ""
};
var addCompany = function addCompany(address) {
  var _address$isCompany = address.isCompany,
    isCompany = _address$isCompany === void 0 ? false : _address$isCompany,
    _address$vatId = address.vatId,
    vatId = _address$vatId === void 0 ? "" : _address$vatId,
    _address$companyName = address.companyName,
    companyName = _address$companyName === void 0 ? "" : _address$companyName;
  if (vatId && companyName) {
    isCompany = true;
  }
  return _objectSpread(_objectSpread({}, address), {}, {
    isCompany: isCompany ? isCompany : false,
    vatId: vatId ? vatId : ""
  });
};
var initialState = {
  email: "",
  shippingAddressSameAsBilling: true,
  billingAddress: emptyAddress,
  shippingAddress: emptyAddress,
  emailConsentForDelivery: false,
  additionalInformation: "",
  orderId: null
};
var setCheckoutData = (0, _toolkit.createAction)("checkout/setCheckoutData");
var checkoutDataSlice = (0, _toolkit.createSlice)({
  name: "checkoutFormData",
  initialState: initialState,
  reducers: {
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    },
    setBillingCountry: function setBillingCountry(state, action) {
      state.billingAddress.country.id = action.payload;
    },
    setShippingCountry: function setShippingCountry(state, action) {
      state.shippingAddress.country.id = action.payload;
    },
    setBillingAddress: function setBillingAddress(state, action) {
      state.billingAddress = action.payload;
    },
    setShippingAddress: function setShippingAddress(state, action) {
      state.shippingAddress = action.payload;
    },
    setShippingAddressSameAsBilling: function setShippingAddressSameAsBilling(state, action) {
      state.shippingAddressSameAsBilling = action.payload;
    },
    setEmailConsentForDelivery: function setEmailConsentForDelivery(state, action) {
      state.emailConsentForDelivery = action.payload;
    },
    setAdditionalInformation: function setAdditionalInformation(state, action) {
      state.additionalInformation = action.payload;
    },
    setEmail: function setEmail(state, action) {
      state.email = action.payload;
    },
    setOrder: function setOrder(state, action) {
      state.orderId = action.payload;
    },
    setAddresses: function setAddresses(state, action) {
      var _action$payload = action.payload,
        billingAddress = _action$payload.billingAddress,
        shippingAddress = _action$payload.shippingAddress,
        email = _action$payload.email;
      var save_in_address_book = shippingAddress.save_in_address_book,
        isParcel = shippingAddress.isParcel,
        isLocker = shippingAddress.isLocker,
        emailShipping = shippingAddress.email,
        shippingAddressWithoutEmail = (0, _objectWithoutProperties2["default"])(shippingAddress, _excluded);
      var emailBilling = billingAddress.email,
        billingAddressWithoutEmail = (0, _objectWithoutProperties2["default"])(billingAddress, _excluded2);
      state.email = email;
      state.billingAddress = addCompany(billingAddressWithoutEmail);
      state.shippingAddress = addCompany(shippingAddressWithoutEmail);
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setCheckoutData, function (state, action) {
      var _action$payload2 = action.payload,
        email = _action$payload2.email,
        shipping = _action$payload2.shipping,
        billing = _action$payload2.billing;
      state.email = email;
      state.billingAddress = billing;
      state.shippingAddress = shipping;
    });
  }
});
exports.checkoutDataSlice = checkoutDataSlice;
var _default = checkoutDataSlice.reducer;
exports["default"] = _default;
var _checkoutDataSlice$ac = checkoutDataSlice.actions,
  setAdditionalInformation = _checkoutDataSlice$ac.setAdditionalInformation,
  setEmailConsentForDelivery = _checkoutDataSlice$ac.setEmailConsentForDelivery,
  setShippingCountry = _checkoutDataSlice$ac.setShippingCountry,
  setBillingCountry = _checkoutDataSlice$ac.setBillingCountry,
  setShippingAddressSameAsBilling = _checkoutDataSlice$ac.setShippingAddressSameAsBilling,
  setEmail = _checkoutDataSlice$ac.setEmail,
  setBillingAddress = _checkoutDataSlice$ac.setBillingAddress,
  setShippingAddress = _checkoutDataSlice$ac.setShippingAddress,
  setAddresses = _checkoutDataSlice$ac.setAddresses,
  setOrder = _checkoutDataSlice$ac.setOrder,
  clearData = _checkoutDataSlice$ac.clearData;
exports.clearData = clearData;
exports.setOrder = setOrder;
exports.setAddresses = setAddresses;
exports.setShippingAddress = setShippingAddress;
exports.setBillingAddress = setBillingAddress;
exports.setEmail = setEmail;
exports.setShippingAddressSameAsBilling = setShippingAddressSameAsBilling;
exports.setBillingCountry = setBillingCountry;
exports.setShippingCountry = setShippingCountry;
exports.setEmailConsentForDelivery = setEmailConsentForDelivery;
exports.setAdditionalInformation = setAdditionalInformation;